import * as React from "react"

function PrevisionIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.3 15.51" {...props}>
      <defs>
        <style>{".cls-1{fill:#003da6}"}</style>
      </defs>
      <g id="Capa_2" data-name="Capa 2">
        <g id="Capa_1-2" data-name="Capa 1">
          <path
            className="cls-1"
            d="M2.1 6.7a.92.92 0 00-1 .88v6a.93.93 0 001 .88h11.05a.93.93 0 001-.88v-6a.92.92 0 00-1-.88zm11.05 8.81H2.1A2 2 0 010 13.57v-6a2 2 0 012.1-1.93h11.05a2 2 0 012.1 1.94v6a2 2 0 01-2.1 1.94"
          />
          <path
            className="cls-1"
            d="M3.62 8.81a.19.19 0 00-.19.19v1a.19.19 0 00.19.18h1.15A.19.19 0 005 10V9a.19.19 0 00-.19-.18zm1.15 2.47H3.62A1.29 1.29 0 012.29 10V9a1.29 1.29 0 011.33-1.25h1.15A1.29 1.29 0 016.1 9v1a1.29 1.29 0 01-1.33 1.24M12.39 13.39H2.86a.53.53 0 110-1.06h9.53a.53.53 0 110 1.06M17.35 3.88H4a.56.56 0 01-.57-.53.56.56 0 01.57-.53h13.35a.56.56 0 01.57.53.56.56 0 01-.57.53"
          />
          <path
            className="cls-1"
            d="M17 9.67a.58.58 0 01-.5-.27.51.51 0 01.21-.72.83.83 0 00.48-.75v-6a.92.92 0 00-1-.88h-11a.92.92 0 00-1 .88v2.12a.54.54 0 01-.57.53.55.55 0 01-.57-.53V1.94A2 2 0 015.15 0h11a2 2 0 012.1 1.94v6a1.9 1.9 0 01-1 1.66.58.58 0 01-.28.07"
          />
        </g>
      </g>
    </svg>
  )
}

export default PrevisionIcon
